var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-emergency-inspect-photos"},[_c('print-photos',{attrs:{"id":_vm.id,"api-name":"emergencyInspectReport"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }